import { createAction } from '../../../../../store.model';
import { ActionType } from '../commitment-narrative.action';
import { FilterOptions } from '../models/filter-options';

export interface ApplyFilters {
    opts?: FilterOptions;
}

export const applyFilters = createAction<ActionType, ApplyFilters>(
    ActionType.COMMITMENT_NARRATIVE__APPLY_FILTERS,
);
